export * from './system-requirements-page.component';
